export default {
    methods: {
        getMessagesBoxElement() {
            const messageList =
                this.$refs.chatMessageList;

            if (
                messageList &&
                messageList.$refs &&
                messageList.$refs.messagesBox
            ) {
                return messageList.$refs.messagesBox;
            }

            return this.$el;
        },

        setMessagesBoxHeight(height) {
            const messagesBox =
                this.getMessagesBoxElement();

            if (!messagesBox) {
                return;
            }

            messagesBox.style.setProperty(
                'height',
                `calc(100dvh - ${height}px)`,
                'important'
            );
        },

        isMessageListNearBottom() {
            const messagesBox =
                this.getMessagesBoxElement();

            if (!messagesBox) {
                return true;
            }

            return (
                messagesBox.scrollHeight -
                messagesBox.scrollTop -
                messagesBox.clientHeight
            ) <= 120;
        },

        chatScrollBottomMethod() {
            const messageList =
                this.$refs.chatMessageList;

            if (
                messageList &&
                typeof messageList.scrollToBottom ===
                    'function'
            ) {
                messageList.scrollToBottom();
                return;
            }

            const messagesBox =
                this.getMessagesBoxElement();

            if (messagesBox) {
                messagesBox.scrollTop =
                    messagesBox.scrollHeight;
            }
        }
    }
};
